export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.allPages = payload;

  return newState;
};
